$(document).ready(function () {
  // Initialize Slick slider
  if($('.frequently-bought-slider.slick-initialized').length){
    
  }else{
    $(".frequently-bought-slider").slick({
      dots: false,
      arrows: true,
      prevArrow: $(".custom-prev-arrow"),
      nextArrow: $(".custom-next-arrow"),
      
      slidesToScroll:1, // Number of slides to scroll
      slidesToShow: 2.5, // Number of slides to show at a time
      responsive: [
        {
          breakpoint: 576, // Breakpoint for smaller screens (tablet)
          settings: {
            slidesToShow: 2.2, // Adjust number of slides to show for tablets
          },
        },
      ],
    });
  }
});
  